import { ExtractProps, withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    prices: {
      squaremeter_price: void
      per_piece_text: void
      incl_tax: void
      excl_tax: void
      eco_tax: {
        ecoTax: string
      }
      excl_delivery_costs: void
      excl_delivery_costs_with_link: { DELIVERYCOSTS: any }
      from: void
      to: void
      flyoutcart_unit: { UNIT: string }
      prices_deliverable: void
      prices_non_deliverable: void
      sku_piece_price_label: void
      series_per_piece_label: {
        unit: string
      }
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) =>
  withTranslations(Component, () =>
    useStaticQuery(graphql`
      query prices_translations {
        squaremeter_price: snippet(group: "prices", name: "squaremeter_price")
        per_piece_text: snippet(group: "prices", name: "per_piece_text")
        incl_tax: snippet(group: "prices", name: "incl_tax")
        excl_tax: snippet(group: "prices", name: "excl_tax")
        eco_tax: snippet(group: "prices", name: "eco_tax")
        excl_delivery_costs: snippet(
          group: "prices"
          name: "excl_delivery_costs"
        )
        excl_delivery_costs_with_link: snippet(
          group: "prices"
          name: "excl_delivery_costs_with_link"
        )
        from: snippet(group: "prices", name: "from")
        to: snippet(group: "prices", name: "to")
        flyoutcart_unit: snippet(group: "prices", name: "flyoutcart_unit")
        prices_deliverable: snippet(group: "prices", name: "prices_deliverable")
        prices_non_deliverable: snippet(
          group: "prices"
          name: "prices_non_deliverable"
        )
        sku_piece_price_label: snippet(
          group: "prices"
          name: "sku_piece_price_label"
        )
        series_per_piece_label: snippet(
          group: "prices"
          name: "series_per_piece_label"
        )
      }
    `)
  )
